/*
 * TemplatePreviewPage Messages
 *
 * This contains all the text for the TemplatePreviewPage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TemplatePreviewPage';

export default defineMessages({
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Close',
  },
  researchMethod: {
    id: `${scope}.researchMethod`,
    defaultMessage: 'Research method',
  },
  chooseTemplate: {
    id: `${scope}.chooseTemplate`,
    defaultMessage: 'Use this template',
  },
  useThisSurvey: {
    id: `${scope}.useThisSurvey`,
    defaultMessage: 'Use this survey',
  },
  changeLater: {
    id: `${scope}.changeLater`,
    defaultMessage: 'You can edit this survey later',
  },
  pressEnterForNextValue: {
    id: `${scope}.chooseTemplate`,
    defaultMessage: 'Press enter for next value',
  },
  startFromScratch: {
    id: `${scope}.startFromScratch`,
    defaultMessage: 'Create from scratch',
  },
  featureUnavailable: {
    id: `${scope}.featureUnavailable`,
    defaultMessage: 'This feature is available on the Elite plan.',
  },
  upgradeYourPlan: {
    id: `${scope}.upgradeYourPlan`,
    defaultMessage: 'Upgrade your Plan',
  },
});
